import React, { useMemo, useCallback } from "react";
import { DEFAULT_OFFER_IMAGE } from "../../../conf";
import ModulePreview from "../ModulePreview";

export default React.memo(() => {
	const defaultOfferData = useMemo(
		() => ({
			offer: {
				heading: "Offer Headline",
				duration: 30,
				discount: 0,
				show_timer: false,
				products: [
					{
						photo_url: DEFAULT_OFFER_IMAGE,
						name: "Product Name",
						price: 100,
						supplementary_images: [
							DEFAULT_OFFER_IMAGE,
							DEFAULT_OFFER_IMAGE,
							DEFAULT_OFFER_IMAGE,
							DEFAULT_OFFER_IMAGE,
						],
						description: `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore
						fugiat tenetur suscipit! Earum illum totam nobis exercitationem
						illo. Quo, dicta. Atque odio facere obcaecati. Numquam voluptate
						ipsa non quis adipisci?`,
					},
				],
				percentage_discount: false,
				display_text: "Your offer description text goes here",
			},
		}),
		[]
	);

	const offerDataMapper = useCallback(
		(requestData, initData) => ({
			...(requestData?.offer ? requestData.offer : initData.offer),
			percentage_discount:
				requestData?.offer?.percentage_discount ||
				initData.offer.percentage_discount,
			display_text:
				requestData?.offer?.display_text || initData.offer.display_text,
		}),
		[]
	);

	return (
		<ModulePreview
			moduleType="offer"
			remoteKey="offer"
			defaultData={defaultOfferData}
			moduleDataMapper={offerDataMapper}
		/>
	);
});
